import React, { useState } from "react";
import { bool } from "prop-types";
import { routerActions } from "connected-react-router";
import { actions as accountsActions } from "reducers/accounts";
import * as i18n from "util/i18n";

import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";

import { ResponsiveHeader } from "pages/_components/header";
import { Col, Row } from "react-bootstrap";
import CustomButton from "pages/_components/CustomButton/CustomButton";

import { TransactionCard, TransactionHeader } from "pages/_components/TransactionCard";
import AgreementSummary from "./components/AgreementSummary";
import { useAgreementTransaction } from "./hooks/useAgreementTransaction";

const PendingTransactionPage = ({ isDesktop }) => {
    const { isLoading, transaction, dispatch, showSignButton, isBackoffice } = useAgreementTransaction();
    const [showMoreData, setShowMoreData] = useState(!isDesktop);

    const handleSignTransaction = () => {
        const { data, idTransaction } = transaction;
        dispatch(accountsActions.setNewAgreement({ ...data, idTransaction }));
        dispatch(routerActions.push("/accounts/agreements/summaryForm"));
    };

    return (
        <>
            <Notification scopeToShow="accounts" />
            {!isBackoffice && (
                <ResponsiveHeader ticket metaTitle="account.agreement.request" backLinkTo="/pendingTransaction/list" />
            )}

            <MainContainer showLoader={isLoading}>
                <TransactionCard transaction={transaction}>
                    <TransactionHeader title="account.agreement.request" />

                    <div className="ticket">
                        <div className="ticket__wrapper">
                            <div className="ticket__header" />
                            <AgreementSummary
                                title="account.agreement.request"
                                isTicket
                                setShowMoreData={setShowMoreData}
                                showMoreData={showMoreData}
                            />
                            <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                        </div>
                    </div>
                </TransactionCard>
                {!isBackoffice && (
                    <Row className="form-actions">
                        <Col xs={12} md={4} mdOffset={showSignButton ? 2 : 4}>
                            <CustomButton
                                func={() => dispatch(routerActions.push("/desktop"))}
                                text="forms.transaction.ticket.actions.backToHome"
                                textType="I18N"
                                className={`btn${showSignButton ? " btn-outline" : " btn-primary"}`}
                            />
                        </Col>
                        {showSignButton && (
                            <Col xs={12} md={4}>
                                <CustomButton
                                    func={handleSignTransaction}
                                    text="forms.signTransaction.link"
                                    textType="I18N"
                                    className="btn btn-primary"
                                />
                            </Col>
                        )}
                    </Row>
                )}
            </MainContainer>
        </>
    );
};

PendingTransactionPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default PendingTransactionPage;
